export enum CalculationStatus {
  BlockBeforeCalc = "BLOCKED_BEFORE_CALC",
  BlockAfterCalc = "BLOCKED_AFTER_CALC",
  Valid = "VALID",
  WaitingForCalculation = "WAITING_FOR_CALCULATION"
}
